export default [
  { label: '', value: '' },
  { label: '$50', value: 50 },
  { label: '$100', value: 100 },
  { label: '$150', value: 150 },
  { label: '$250', value: 250 },
  { label: '$500', value: 500 },
  { label: '$1,000', value: 1000 },
  { label: '$1,500', value: 1500 },
  { label: '$2,000', value: 2000 },
  { label: '$2,500', value: 2500 },
  { label: '$3,000', value: 3000 },
  { label: '$3,500', value: 3500 },
  { label: '$4,000', value: 4000 },
  { label: '$4,500', value: 4500 },
  { label: '$5,000', value: 5000 },
];



// WEBPACK FOOTER //
// ./src/constants/dollarIncrements.js